import { IOrganization, IVariant, Organization, Variant } from '@acies/domain';

export interface IOrganizationVariant {
	organization: IOrganization;
	variants: IVariant[];
}

export class OrganizationVariant implements IOrganizationVariant {
	public organization: Organization;
	public variants: Variant[];
	public constructor({ organization, variants }: IOrganizationVariant) {
		this.organization = organization;
		this.variants = variants;
	}
}
